import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    portfolioTitle: {
        padding: '1.5rem',
        borderBottom: `1px solid ${theme.brand.border}`,
    },
    portfolioValue: {
        padding: '50px 0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: `1px solid ${theme.brand.border}`,
        color: theme.brand.NormalText,
    },
    row: {
        display: 'flex',
        alignItems: 'center',
    },
    dollarSign: {
        fontSize: 32,
        fontFamily: '"Heebo", sans-serif',
    },
    valueDollars: {
        fontSize: 40,
        fontWeight: 'bold',
        fontFamily: '"Heebo", sans-serif',
    },
    valueCents: {
        display: 'block',
        fontSize: 24,
        marginTop: -10,
        fontFamily: '"Heebo", sans-serif',
    },
    portfolioStats: {
        flex: 1,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    list: {
        padding: 0,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        '& li': {
            borderBottom: `1px solid ${theme.brand.border}`,
            paddingBottom: 0,
        },
        '& li:last-child': {
            borderBottom: `none`,
        },
    },
    listItem: {
        flex: 1,
        padding: '5px 0',
        '& > div:first-child': {
            padding: '12px 20px',
        },
        '& > div:last-child': {
            textAlign: 'right',
        },
    },
    listItemRoot: {
        height: '100%',
    },
    portfolioFooter: {
        padding: '30.5px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    primary: {
        color: theme.brand.SecondaryText,
    },
    bgWhite: {
        backgroundColor: 'white',
        color: 'white',
        boxShadow: theme._shadows.icon,
    },
    bgAxn: {
        backgroundColor: theme.brand.axion,
        color: 'white',
        boxShadow: theme._shadows.icon,
        filter: theme.mode === 'supernova' ? 'drop-shadow(0px 0px 5px rgba(255, 143, 0, 0.8))' : '',
    },
    logo: {
        height: '65%',
    },
    mt6: {
        marginTop: 6,
    },
}));

export default useStyles;
